import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import Files from 'react-files';
import {Button, ControlLabel, FormControl, FormGroup, HelpBlock, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import {withRouter} from "react-router-dom";

import CollapsiblePanel from "../../components/Accordion/CollapsiblePanel";
import Loading from "../../components/Loading/index";

class VideoForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            questions: [],
            video: null,
            showModal: false,
            loading: this.props.match.params.id ? true : false
        };

        this.handleChangeVideoName = this.handleChangeVideoName.bind(this);
        this.handleChangeVideoDeviceType = this.handleChangeVideoDeviceType.bind(this);
        this.handleChangeVideoFile = this.handleChangeVideoFile.bind(this);
        this.handleRemoveVideoFile = this.handleRemoveVideoFile.bind(this);
        this.handleUploadVideo = this.handleUploadVideo.bind(this);
        this.handleShowVideo = this.handleShowVideo.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleRemoveVideo = this.handleRemoveVideo.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getQuestions();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken && nextProps.active && !this.state.loaded) {
            this.getQuestions();
        }
    }

    getQuestions() {
        if (this.props.match.params.id) {
            axios.get(this.props.api.specials + "/" + this.props.match.params.id)
            .then((response) => {
                this.setState({
                    name: response.data.name,
                    questions: response.data.questions.map((question) => {
                        return {
                            ...question,
                            uploadedVideo: {
                                name: '',
                                deviceType: '',
                                files: []
                            },
                            inProcess: false
                        }
                    }),
                    validation: {
                        states: response.data.questions.map(() => {
                            return {name: null, deviceType: null, files: null}
                        }),
                        messages: response.data.questions.map(() => {
                            return {name: '', deviceType: '', files: ''}
                        })
                    },
                    loading: false
                })
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst speciál!');
                this.props.history.push('/specials');
                console.log("Axios error: ", error);
            })
        }
    }

    handleChangeVideoName(event, questionIndex) {
        let value = event ? event.target.value : this.state.questions[questionIndex].uploadedVideo.name;
        let questions = this.state.questions;
        questions[questionIndex].uploadedVideo.name = value;

        let validation = this.state.validation;
        validation.states[questionIndex].name = value === '' ? 'error' : 'success';
        validation.messages[questionIndex].name = value === '' ? 'Název videa nesmí být prázdný!' : '';

        this.setState({
            questions,
            validation
        })
    }

    handleChangeVideoDeviceType(event, questionIndex) {
        let value = event ? event.target.value : this.state.questions[questionIndex].uploadedVideo.deviceType;
        let questions = this.state.questions;
        questions[questionIndex].uploadedVideo.deviceType = value;

        let validation = this.state.validation;
        validation.states[questionIndex].deviceType = value === '' ? 'error' : 'success';
        validation.messages[questionIndex].deviceType = value === '' ? 'Typ zařízení nesmí být prázdný!' : '';

        this.setState({
            questions,
            validation
        })
    }

    handleChangeVideoFile(files, questionIndex) {
        let value = files ? files : this.state.questions[questionIndex].uploadedVideo.files;
        let questions = this.state.questions;
        questions[questionIndex].uploadedVideo.files = value;

        let validation = this.state.validation;
        validation.states[questionIndex].files = value.length === 0 ? 'error' : 'success';
        validation.messages[questionIndex].files = value.length === 0 ? 'Musíte vložit video!' : '';

        this.setState({
            questions,
            validation
        });
    }

    handleRemoveVideoFile(questionIndex) {
        let questions = this.state.questions;
        questions[questionIndex].uploadedVideo.files = [];

        let validation = this.state.validation;
        validation.states[questionIndex].files = null;
        validation.messages[questionIndex].files = '';

        this.setState({
            questions,
            validation
        });
    }

    handleShowVideo(questionIndex, videoIndex) {
        let video = this.state.questions[questionIndex].videos[videoIndex];
        this.setState({
            showModal: true,
            video
        })
    }

    handleCloseModal() {
        this.setState({
            showModal: false
        })
    }

    handleUploadVideo(questionIndex) {
        if (this.isValid(questionIndex)) {
            this.upload(this.state.questions[questionIndex]);
            let questions = this.state.questions;
            questions[questionIndex].inProcess = true;
            this.setState({
                questions
            })
        }
    }

    handleRemoveVideo(questionIndex, videoIndex) {
        let question = this.state.questions[questionIndex];
        let video = question.videos[videoIndex];
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.post(this.props.api.questionVideoDelete + "/" + question.id, {
            urlLink: video.urlLink
        }, config).then(() => {
            this.getQuestions();
        }).catch((error) => {
            console.log("Axios error: ", error);
        })

    }

    isValid(questionIndex) {
        this.handleChangeVideoName(null, questionIndex);
        this.handleChangeVideoDeviceType(null, questionIndex);
        this.handleChangeVideoFile(null,questionIndex);

        return (Object.values(this.state.validation.states[questionIndex]).indexOf('error') < 0);
    }

    upload(question) {
        let video = question.uploadedVideo;
        console.log("Upload video:", video);
        let data = new FormData();
        data.append('name', video.name);
        data.append('deviceType', video.deviceType);
        data.append('questionId', question.id);
        data.append('videoFile',video.files[0]);

        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.post(this.props.api.questionVideoUpload, data, config)
        .then(() => {
            this.getQuestions();
        })
        .catch((error) => {
            console.error('Error axios: ', error);
        })
    }


    render () {
        let title = "Správa videí pro speciál: " + this.state.name;
        let questions = this.state.questions;

        const tooltipView = <Tooltip id="tooltip-view">Zobrazit video</Tooltip>;
        const tooltipRemove = <Tooltip id="tooltip-remove">Odstranit video</Tooltip>;

        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>{title}</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {
                        this.state.loading ? <Loading/> :
                            <div className="accordion">
                                {
                                    [...questions].map((question, questionIndex) => {
                                        let heading = "Otázka č. " + question.name;
                                        let videos = question.videos;
                                        let uploadedVideo = question.uploadedVideo;
                                        let messages = this.state.validation.messages[questionIndex];
                                        let states = this.state.validation.states[questionIndex];
                                        return (
                                            <CollapsiblePanel key={questionIndex} heading={heading}>
                                                <div className="col-lg-5">
                                                    <h2>Seznam videí</h2>
                                                    <div className='files-list'>
                                                        <ul>
                                                            {videos && videos.map((video, videoIndex) => {
                                                                    let extension = (/[.]/.exec(video.urlLink)) ? /[^.]+$/.exec(video.urlLink) : undefined;
                                                                    return (
                                                                        <li className='files-list-item' key={videoIndex}>
                                                                            <div className='files-list-item-preview'>
                                                                                <div
                                                                                    className='files-list-item-preview-extension'>
                                                                                    {extension}
                                                                                </div>
                                                                            </div>
                                                                            <div className='files-list-item-content'>
                                                                                <div
                                                                                    className='files-list-item-content-item files-list-item-content-item-1'>
                                                                                    {video.name}
                                                                                </div>
                                                                                <div
                                                                                    className='files-list-item-content-item files-list-item-content-item-2'>
                                                                                    Typ zařízení: {video.deviceType}
                                                                                </div>
                                                                            </div>
                                                                            <div className='files-list-item-options'>
                                                                                <OverlayTrigger placement="top"
                                                                                                overlay={tooltipView}>
                                                                                    <FontAwesome name="eye" size='2x'
                                                                                                 onClick={() => this.handleShowVideo(questionIndex, videoIndex)}
                                                                                                 className="cursor-p"
                                                                                    />
                                                                                </OverlayTrigger>
                                                                                {' '}
                                                                                <OverlayTrigger placement="top"
                                                                                                overlay={tooltipRemove}>
                                                                                    <FontAwesome name="trash" size='2x'
                                                                                                 onClick={() => this.handleRemoveVideo(questionIndex, videoIndex)}
                                                                                                 className="cursor-p"
                                                                                    />
                                                                                </OverlayTrigger>
                                                                            </div>
                                                                        </li>
                                                                    );
                                                                }
                                                            )}
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="col-lg-offset-1 col-lg-6">
                                                    <h2>Nové video</h2>
                                                    <div key={questionIndex}>
                                                        <FormGroup controlId="videoName" validationState={states.name}>
                                                            <ControlLabel>Název videa:</ControlLabel>
                                                            <FormControl type="text" value={uploadedVideo.name}
                                                                         onChange={(event) => this.handleChangeVideoName(event, questionIndex)}/>
                                                            <FormControl.Feedback/>
                                                            <HelpBlock>{messages.name}</HelpBlock>
                                                        </FormGroup>
                                                        <FormGroup controlId="videoDeviceType"
                                                                   validationState={states.deviceType}>
                                                            <ControlLabel>Typ zařízení:</ControlLabel>
                                                            <FormControl componentClass="select"
                                                                         placeholder="Vyberte typ zařízení"
                                                                         defaultValue={0}
                                                                         onChange={(event) => this.handleChangeVideoDeviceType(event, questionIndex)}>
                                                                <option value={0} disabled>Vyberte typ zářízení</option>
                                                                <option value="mobil">mobil</option>
                                                                <option value="tablet">tablet</option>
                                                            </FormControl>
                                                            <FormControl.Feedback/>
                                                            <HelpBlock>{messages.deviceType}</HelpBlock>
                                                        </FormGroup>
                                                        <FormGroup controlId="videoFiles"
                                                                   validationState={states.files}>
                                                            <Files
                                                                ref='files'
                                                                className='files-dropzone-list'
                                                                style={{height: '100px'}}
                                                                onChange={(files) => this.handleChangeVideoFile(files, questionIndex)}
                                                                multiple={false}
                                                                clickable
                                                                accepts={['video/*']}
                                                            >
                                                                {
                                                                    uploadedVideo.files.length > 0
                                                                        ? <div className='files-list'>
                                                                            <ul>
                                                                                {uploadedVideo.files.map((file) =>
                                                                                    <li className='files-list-item'
                                                                                        key={file.id}>
                                                                                        <div
                                                                                            className='files-list-item-preview'>
                                                                                            {file.preview.type === 'image'
                                                                                                ? <img
                                                                                                    className='files-list-item-preview-image'
                                                                                                    src={file.preview.url}
                                                                                                    alt=""/>
                                                                                                : <div
                                                                                                    className='files-list-item-preview-extension'>{file.extension}</div>}
                                                                                        </div>
                                                                                        <div
                                                                                            className='files-list-item-content'>
                                                                                            <div
                                                                                                className='files-list-item-content-item files-list-item-content-item-1'>{file.name}</div>
                                                                                            <div
                                                                                                className='files-list-item-content-item files-list-item-content-item-2'>{file.sizeReadable}</div>
                                                                                        </div>
                                                                                    </li>
                                                                                )}
                                                                            </ul>
                                                                        </div>
                                                                        : <div>Zde vložte video</div>
                                                                }
                                                            </Files>
                                                            <HelpBlock>{messages.files}</HelpBlock>
                                                        </FormGroup>
                                                        <Button className="btn btn-danger"
                                                                onClick={() => this.handleRemoveVideoFile(questionIndex)}>Smazat</Button>
                                                        <Button className="btn btn-success"
                                                                onClick={() => this.handleUploadVideo(questionIndex)}>Nahrát</Button>
                                                        {question.inProcess && <Loading/>}
                                                    </div>
                                                </div>
                                            </CollapsiblePanel>
                                        );
                                    })
                                }
                            </div>
                            }
                        </div>
                        {
                            this.state.video &&
                            <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
                            <Modal.Header closeButton>
                            <Modal.Title>Náhled videa {this.state.video.name}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            <p><b>Typ zařízení: </b>{this.state.video.deviceType}</p>
                            <video className="center-block" width="320" height="240" controls>
                            <source src={`${__APIURL__}/${this.state.video.urlLink}`}/>
                            </video>
                            </Modal.Body>
                            <Modal.Footer>
                            <Button onClick={this.handleCloseModal}>Zavřít</Button>
                            </Modal.Footer>
                            </Modal>
                        }
            </div>
        );
    }
}

export default withRouter(VideoForm);



/** WEBPACK FOOTER **
 ** ./src/containers/Specials/VideoForm.js
 **/